<template>                
  <tr class="pricing-table__row">
    <td class="pricing-table__cell pricing-table__cell--smed">
      <button class="btn btn-secondary btn-icon pricing-table__btn pricing-table__btn--add"
        @click="toggleExpand"
      ><i class="fa" :class="{ 'fa-plus' : !expandRows, 'fa-minus' : expandRows }"></i></button>
      <template v-if="startMonthFormatted">
        {{ startMonthFormatted }}
      </template>
      <template v-else>{{ undefinedLabel }}</template>
    </td>
    <td class="pricing-table__cell pricing-table__cell--sm">
      <template v-if="value">{{ value }}<span>-Mo</span></template>
      <template v-else="value">{{ undefinedLabel }}</template>
    </td>
    <td class="pricing-table__cell">{{ formatNumberValue(usageFormatted, 0) }}</td>
    <td class="pricing-table__cell pricing-table__cell--table-parent">
      <table class="pricing-table__subtable">
        <component-row 
          v-if="primaryPricingComponent && primaryPricingComponent.slug != 'total'"
          :component-id="primaryPricingComponent.id"
          :name="primaryPricingComponent.name"
          :displayUnit="displayUnit"
          :slug="primaryPricingComponent.slug"
          :pricing-alerts="filteredPricingAlerts"
          :pricing-data="pricingData"
          :term-length="termLength"
          :term-usage="usage"
          :start-month="startMonth"
          :alert-trigger="alertTrigger"
          :created="created"
          :updated="updated"
        ></component-row>
        <total-row 
          v-if="primaryPricingComponent && primaryPricingComponent.slug === 'total'"
          name="Total"
          :displayUnit="displayUnit"
          slug="total"
          :pricing-alerts="filteredPricingAlerts"
          :pricing-data="pricingData"
          :term-length="termLength"
          :term-usage="usage"
          :start-month="startMonth"
          :alert-trigger="alertTrigger"
          :created="created"
          :updated="updated"
        ></total-row>
        <template v-if="expandRows">
          <component-row 
            v-for="(pricingComponent, index) in filteredPricingComponents"
            :component-id="pricingComponent.id"
            :name="pricingComponent.name"
            :displayUnit="displayUnit"
            :slug="pricingComponent.slug"
            :key="index"
            :pricing-alerts="filteredPricingAlerts"
            :pricing-data="pricingData"
            :term-length="termLength"
            :term-usage="usage"
            :start-month="startMonth"
            :alert-trigger="alertTrigger"
            :created="created"
            :updated="updated"
          ></component-row>
          <total-row 
            v-if="primaryPricingComponent && primaryPricingComponent.slug != 'total'"
            name="Total"
            :displayUnit="displayUnit"
            slug="total"
            :pricing-alerts="filteredPricingAlerts"
            :pricing-data="pricingData"
            :term-length="termLength"
            :term-usage="usage"
            :start-month="startMonth"
            :alert-trigger="alertTrigger"
            :created="created"
            :updated="updated"
          ></total-row>
        </template>
      </table>
    </td>  
  </tr>
</template>

<script>
import moment from 'moment'
import ComponentRow from './ComponentRow.vue'
import TotalRow from './TotalRow.vue'
import { formatNumber } from '../../../common/helpers'

export default {
  props: ['displayUnit', 'startMonth', 'termLength', 'usage', 'primaryPricingComponent', 'pricingAlerts', 'pricingData', 'alertTrigger', 'created', 'updated'],
  components: {
    'component-row': ComponentRow,
    'total-row': TotalRow
  },
  data() {
    return {
      undefinedLabel: '-Not Defined-',
      expandRows: false,
    }
  },
  computed: {
    termPricingData() {
      if (this.pricingData && this.termLength) {
        return this.pricingData[this.termLength]
      }
    },
    startMonthFormatted() {
      if (moment(this.startMonth).format('MMM YYYY') === 'Invalid date') {
        return false
      } 

      return moment(this.startMonth).format('MMM YYYY')
    },
    usageFormatted() {
      if (Object.keys(this.pricingData).length && this.pricingData.terms[this.termLength]) {
        return Math.round(this.pricingData.terms[this.termLength].usage)
      }
    },
    value() {
      return this.termLength
    },
    pricingComponents() {
      return this.$store.getters.dashboardPricingComponents
    },
    filteredPricingComponents() {
      if (this.pricingComponents && this.primaryPricingComponent) {
        return this.pricingComponents.filter(component => component.slug != this.primaryPricingComponent.slug)
      }
    },
    filteredPricingAlerts() {
      if (this.pricingAlerts) {
        return this.pricingAlerts.filter(alert => alert.term === this.termLength)
      }
    },
    expandAllPricingRows() {
      return this.$store.getters.expandAllPricingRows
    },
    dashboardSortUtility() {
      if (this.$store.getters.dashboardSortUtility){
        return this.$store.getters.dashboardSortUtility
      }
    }
  },
  methods: {
    toggleExpand() {
      this.expandRows = !this.expandRows
    },
    formatNumberValue(val, decimals) {
      return formatNumber(val, decimals)
    }
  },
  watch: {
    expandAllPricingRows(bool) {
      this.expandRows = bool
    },
    dashboardSortUtility(bool) {
      this.expandRows = false
    }
  }
}
</script>
